import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import { useCallback } from 'react';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { forceReload } from '../../redux/actions/commonReduxActions';
import { thunkCloseCurrentMessageBox } from '../../redux/actions/messageBoxesActions';
import { useAppDispatch } from '../../redux/store';
import { HtmlRenderer } from '../htmlAreas/htmlRenderer';
export const ConfirmWindowMessageBoxContents = ({ messageBox }) => {
    const { buttons, isHtmlMessage } = messageBox;
    const dispatch = useAppDispatch();
    const socketSend = useSocketSend();
    /**
     * Converts the message input (string | string[] | undefined) to string[].
     */
    const getMessages = useCallback(() => {
        if (!messageBox.message) {
            return [];
        }
        if (Array.isArray(messageBox.message)) {
            return messageBox.message;
        }
        return [messageBox.message];
    }, [messageBox.message]);
    const onClickButton = useCallback(({ actions, closeAfterClick }) => {
        actions.forEach((action) => {
            switch (action.type) {
                case 'outbound': {
                    socketSend(action.outbound);
                    break;
                }
                case 'raw': {
                    console.warn(`Unhandled confirm window raw string: ${action.value}`);
                    break;
                }
                case 'refresh': {
                    dispatch(forceReload());
                    break;
                }
            }
        });
        if (closeAfterClick) {
            dispatch(thunkCloseCurrentMessageBox());
        }
    }, [dispatch, socketSend]);
    return (_jsxs(_Fragment, { children: [getMessages().map((message, i) => (_jsx(DialogContentText, { children: isHtmlMessage ? _jsx(HtmlRenderer, { html: message }) : message }, i))), buttons.length > 0 && (_jsx(DialogActions, { children: buttons.map((button, i) => {
                    return (_jsx(Button, { onClick: () => onClickButton(button), variant: 'contained', size: 'large', children: button.label }, i));
                }) }))] }));
};
